import axios from 'axios';

// API have white list domain filter works only
// on production environment domain mikrorachunek.pl

const isProductionAPI = true;
const efileAPI = axios.create({
    baseURL: isProductionAPI ?
        'https://api.faktury.fillup.pl/api' :
        'https://api.faktury.test.fillup.pl/api'
});

export const postPaymentTaxPrepare = async (data) =>
    efileAPI.post('/payment/unlogged/tax/prepare', data);

export const getPaymentStatus = (paymentUuid, token) =>
    efileAPI.get(`/payment/status/${paymentUuid}/${token}`);

export const getPaymentSend = (paymentUuid, token) =>
    efileAPI.get(`/payment/send/${paymentUuid}/${token}`);